import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

import { Icon, getPrettyNumber } from "aible";
import Select from "react-select";

import AibleStep from "containers/CreateWizard/AibleStep";

import SelectDataset from "components/CreateWizard/Academic/SelectDataset";
import ProblematicPredictors from "components/CreateWizard/Academic/ProblematicPredictors";
import { ProblematicPredictorLabel, ProblematicPredictorBar } from "components/CreateWizard/Dataset/Correlation";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

import { DATA_CHECKS } from "containers/Home/reducer";

import styles from "./style.module.css";

function handlePlurals(count, value = "", noPlural = false) {
  return value + (noPlural || count === 1 ? "" : "s");
}

const VALIDATION_MESSAGES = [
  {
    message: ["too many values", "It would be discarded."],
    type: "high cardinality field",
    action: "would be ignored"
  },
  {
    message: ["It would be discarded."],
    type: "column",
    action: "would be ignored"
  },
  {
    message: ["missing values", "(", ")"],
    type: "column",
    count: 0,
    action: "with missing values would be updated"
  },
  {
    message: ["too many values", "most informative values", "flagged and included in the modeling step"],
    type: "high cardinality field",
    action: "would be updated"
  }
];

function checkMessage(message, checkArr) {
  for (let i = 0; i < checkArr.length; i++) {
    if (!message.toLowerCase().includes(checkArr[i].toLowerCase())) {
      return false;
    }
  }
  return true;
}

function parseValidation(updatedColumns) {
  const retValidation = VALIDATION_MESSAGES.map((validation) => ({
    ...validation,
    value: []
  }));
  const extra = {
    type: "column",
    action: "would be updated for other reasons",
    value: []
  };
  updatedColumns.forEach((col) => {
    let found = false;
    const message = col.metadata && col.metadata.message ? col.metadata.message : col.message;

    for (let i = 0; i < retValidation.length; i++) {
      if (!found && checkMessage(message, retValidation[i].message)) {
        retValidation[i].value.push(message);
        found = true;
        if (retValidation) break;
      }
    }
    if (!found) {
      extra.value.push(message);
    }
  });
  if (retValidation.length < 1) {
    extra.action = "would be updated";
  }
  retValidation.push(extra);
  return retValidation.filter((elem) => elem.value.length);
}

export default class AcademicReviewDataset extends React.PureComponent {
  checkIsProblematicPredictor(column) {
    const { problematicPredictors } = this.props;
    if (problematicPredictors) {
      for (let i = 0; i < problematicPredictors.length; i++) {
        if (problematicPredictors[i].label === column) {
          return column + " might also be a Problematic Predictor";
        }
      }
    }
    return undefined;
  }

  renderUserAdjustments() {
    const {
      blueprintId,
      id,
      isShow,
      options,

      step,
      index,

      selectedDataset,
      ignored,
      transformed,

      datasetView,
      updateSelection,

      isAiReady,
      aiReadyFields
    } = this.props;

    const dataChecks = DATA_CHECKS;

    const updatedColumns = (selectedDataset && selectedDataset.warnings) || [];
    const ignoredFields = (Object.keys(ignored) || []).filter((key) => ignored[key]);
    const ignoredColumns = ignoredFields.concat(
      updatedColumns.filter((w) => w.message.includes("ignored")).map((w) => w.message)
    );

    return (
      <React.Fragment>
        <ReviewDatasetHeader
          error={!isAiReady}
          header={"User Adjustments"}
          icon={
            <Icon
              type={"list"}
              isRound
              background={transformed.length || ignoredFields.length ? "green" : "light-grey"}
              style={{ padding: "5px" }}
              size={24}
            />
          }
        />
        <div className={styles.datasetReviewContent}>
          {transformed.length || ignoredFields.length ? (
            <React.Fragment>
              {transformed.length ? (
                <ReviewDatasetItem
                  text={transformed.length + (" column" + handlePlurals(transformed.length) + " added")}
                  overlayTitle={handlePlurals(transformed.length, "Column") + " added"}
                  overlay={
                    <div className={styles.datasetReviewPopup}>
                      {transformed.map((w, i) => (
                        <div className={styles.datasetReviewRow} key={i}>
                          <span>
                            {(w.fieldOne && w.fieldOne.label ? w.fieldOne.label : "") +
                              " " +
                              (w.operation && w.operation.label && w.operation.label !== "Interaction"
                                ? w.operation.label
                                : "and") +
                              " " +
                              (w.fieldTwo && w.fieldTwo.label ? w.fieldTwo.label : "")}
                          </span>
                        </div>
                      ))}
                    </div>
                  }
                />
              ) : (
                ""
              )}
              {ignoredColumns.length ? (
                <ReviewDatasetItem
                  text={ignoredColumns.length + (" column" + handlePlurals(ignoredColumns.length) + " ignored")}
                  overlayTitle={handlePlurals(transformed.length, "Column") + " ignored"}
                  overlay={
                    <div className={styles.datasetReviewPopup}>
                      {ignoredColumns.map((w, i) => (
                        <div className={styles.datasetReviewRow} key={i + w}>
                          <span>{w}</span>
                        </div>
                      ))}
                    </div>
                  }
                />
              ) : (
                ""
              )}
            </React.Fragment>
          ) : (
            <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
              {"No user adjustments have been made."}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const {
      blueprintId,
      id,
      isShow,
      options,

      step,
      index,

      selectedDataset,
      outcomeType,

      selectedSuccess,
      successOptions,
      successOptionsWarning,
      updateSuccess,
      updateSplitColumn,
      ignored,
      updateIgnored,
      transformed,
      splitOptions,
      splitColumn,
      datasetView,
      updateSelection,
      isRetrain,
      isAiReady,
      aiReadyFields,
      notAiReadyFields,
      aiReadyWarning,
      isMultiCategoryOutcome,

      problematicPredictors,
      predictors,

      customMappings,
      customMappingOptions,
      validCustomMappings,
      setCustomMapping,

      isDataMode,
      noOutcome
    } = this.props;

    const hasAiMetrics =
      isAiReady !== undefined && aiReadyFields && notAiReadyFields && (aiReadyFields.length || notAiReadyFields.length);

    const isRegressionDataset = outcomeType === "number";
    const isSuccessSelected = isDataMode || (selectedDataset && (selectedSuccess || isRegressionDataset));

    const dataChecks = DATA_CHECKS;
    const dataChecksPassed = dataChecks.length;

    const rowCount = selectedDataset && selectedDataset.rowCount;
    const columnCount = selectedDataset && Object.keys(selectedDataset.fields).length;

    const updatedColumns = (selectedDataset && selectedDataset.warnings) || [];
    const ignoredFields = (Object.keys(ignored) || []).filter((key) => ignored[key]);
    const ignoredColumns = ignoredFields.concat(
      updatedColumns.filter((w) => w.message.includes("ignored")).map((w) => w.message)
    );

    const groupedUpdates = parseValidation(updatedColumns);

    const stepMessage = hasAiMetrics
      ? isAiReady
        ? "Your dataset is AI ready for predicting " + selectedDataset.outcome + "!"
        : "Your dataset is not AI ready"
      : "No AI readiness metrics found";

    return (
      <div className={styles.datasetReview} style={{ width: "100%", opacity: isShow === true ? 1 : 0 }}>
        <div id="academicReviewDataset" style={{ width: "100%" }}>
          <AibleStep
            id={id}
            bId="academicReviewDataset"
            message={isDataMode ? <strong>{stepMessage}</strong> : stepMessage}
            secondaryMessage={
              hasAiMetrics
                ? "Aible evaluated " +
                  columnCount +
                  " column" +
                  handlePlurals(columnCount) +
                  " across " +
                  dataChecks.length +
                  " different validation check" +
                  handlePlurals(dataChecksPassed)
                : ""
            }
            isBreak
            hide={!selectedDataset}
            icon={
              <Icon
                type={!isAiReady ? "times" : "check"}
                isRound
                background={!isAiReady ? "red" : "green"}
                style={!isAiReady ? { padding: "5px", marginRight: "20px" } : { marginRight: "20px" }}
                size={32}
              />
            }
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
            messageClassName={styles.messagePadLeft}
          >
            <div
              className={styles.academicDatasetWrapper + " " + styles.reviewDatasetWrapper}
              style={selectedDataset ? {} : { marginTop: "0px" }}
            >
              {isRetrain !== true && (
                <div className={styles.chooseDataset} style={selectedDataset ? {} : { width: "100%" }}>
                  <SelectDataset
                    id={id}
                    selectedDataset={selectedDataset}
                    datasetView={datasetView}
                    updateSelection={updateSelection}
                  />
                </div>
              )}
              {selectedDataset ? (
                <div className={styles.dataReviewColumns}>
                  {/* <ReviewDatasetColumn>
                    <div className={styles.datasetReviewHeader}>
                      <span className={globalStyles.h1 + " "  + globalStyles.bold}>{dataChecksPassed}</span>
                      {"Data Validation Checks Completed"}
                    </div>
                    <div className={styles.datasetReviewContent}>
                      {dataChecks.map((c, i) => (
                        <div className={styles.datasetReviewRow} key={i}>
                          <div className={styles.datasetReviewCheck}>
                            <Icon type={"check"} size={10}/>
                          </div>
                          <span>{c}</span>
                        </div>
                      ))}
                    </div>
                  </ReviewDatasetColumn> */}
                  <ReviewDatasetColumn>
                    <ReviewDatasetHeader error={false} header={"Data Validation"} />
                    <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
                      {updatedColumns.length +
                        " " +
                        handlePlurals(updatedColumns.length, "update") +
                        " will be automatically applied when using the dataset to address the following issues "}
                    </div>
                    <div className={styles.datasetReviewContent}>
                      <ReviewDatasetItem
                        text={getPrettyNumber(columnCount) + (" Column" + handlePlurals(columnCount) + " Scanned")}
                      />
                      <ReviewDatasetItem
                        text={getPrettyNumber(rowCount) + (" Row" + handlePlurals(rowCount) + " Scanned")}
                      />
                      <ReviewDatasetItem
                        text={
                          getPrettyNumber(dataChecks.length) +
                          "  " +
                          handlePlurals(dataChecks.length, "Data Check") +
                          " Completed"
                        }
                        overlayTitle={"Data Checks"}
                        overlay={
                          <div className={styles.datasetReviewPopup}>
                            {DATA_CHECKS.map((w, i) => (
                              <ReviewDatasetItem text={w} key={i + w} />
                            ))}
                          </div>
                        }
                      />
                      {groupedUpdates.length ? (
                        <React.Fragment>
                          <div className={styles.datasetReviewDivider} />
                          <div className={styles.datasetReviewSubContent}>
                            {groupedUpdates.map((update, i) => {
                              const updateText =
                                getPrettyNumber(update.value.length) +
                                " " +
                                (handlePlurals(update.value.length, update.type, update.noPlural) +
                                  " " +
                                  update.action);
                              return (
                                <ReviewDatasetItem
                                  key={update.type + i}
                                  text={<strong>{updateText}</strong>}
                                  overlayTitle={updateText}
                                  overlay={
                                    <div className={styles.datasetReviewPopup}>
                                      {update.value.map((w, i) => (
                                        <div className={styles.datasetReviewRow} key={i + w}>
                                          <span>{w}</span>
                                        </div>
                                      ))}
                                    </div>
                                  }
                                />
                              );
                            })}
                          </div>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </div>
                  </ReviewDatasetColumn>
                  {isDataMode || noOutcome || isRetrain ? (
                    ""
                  ) : (
                    <ReviewDatasetColumn>
                      <ReviewDatasetHeader
                        icon={selectedSuccess ? undefined : <Icon type={"target"} size={24} />}
                        header={"Select Outcome"}
                      />
                      {/* <div className={styles.selectSubheader} style={{marginLeft: "0px"}}>
                        {"Aible will run an analysis for the selected outcome to evaluate this dataset for AI readiness"}
                      </div> */}
                      {selectedDataset ? (
                        <div className={styles.chooseSuccess}>
                          <div className={styles.selectHeaderR}>
                            {"Predict " + selectedDataset.outcome + (isDataMode || isRegressionDataset ? "" : " is:")}
                          </div>
                          {isDataMode || isRegressionDataset ? (
                            ""
                          ) : (
                            <Select
                              key={selectedSuccess ? "success" : "undefined"}
                              value={selectedSuccess}
                              onChange={(value) => updateSuccess(value)}
                              options={successOptions}
                              className={styles.outcomePicker}
                              placeholder="Select Value"
                              menuPlacement="bottom"
                              isMulti={successOptions && successOptions.length > 2}
                            />
                          )}
                          {successOptionsWarning ? (
                            <div className={styles.successWarning}>
                              <Icon type={"warning"} size={14} style={{ display: "inline-block" }} />
                              <span>{successOptionsWarning}</span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </ReviewDatasetColumn>
                  )}
                  {isDataMode || !selectedDataset || !customMappings.length ? (
                    ""
                  ) : (
                    <ReviewDatasetColumn>
                      <ReviewDatasetHeader
                        icon={validCustomMappings ? undefined : <Icon type={"target"} size={24} />}
                        header={"Field Mapping"}
                      />
                      {customMappings.map((cMap, i) => {
                        return (
                          <React.Fragment key={"cMap-" + i}>
                            <div>{cMap.label}</div>
                            <div className={styles.splitField}>
                              <Select
                                options={customMappingOptions}
                                onChange={(val) => setCustomMapping(cMap.label, val ? val.value : val)}
                                value={cMap ? { label: cMap.value, value: cMap.value } : undefined}
                              />
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </ReviewDatasetColumn>
                  )}
                  {isRetrain !== true && (
                    <ReviewDatasetColumn isLarge>
                      <ReviewDatasetHeader header={"Split Column"} />
                      <div>{"Would you like to split on a column?"}</div>
                      <div className={styles.splitField}>
                        <Select
                          options={splitOptions}
                          isClearable
                          onChange={(val) => updateSplitColumn(val ? val.value : val)}
                          value={splitColumn ? { label: splitColumn, value: splitColumn } : undefined}
                        />
                      </div>
                    </ReviewDatasetColumn>
                  )}
                  <ReviewDatasetColumn isLarge>
                    <ReviewDatasetHeader
                      icon={isMultiCategoryOutcome ? <Icon type={"warning"} size={22} /> : undefined}
                      error={!isAiReady}
                      header={"AI Validation"}
                    />
                    <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
                      {hasAiMetrics
                        ? "Aible scanned the dataset for AI readiness and found that your outcome" +
                          " is" +
                          (isAiReady ? "" : " not") +
                          " appropriate for AutoML modeling"
                        : !isMultiCategoryOutcome
                          ? "No AI readiness metrics found." +
                            (!aiReadyWarning ? " Please reupload this dataset to refresh the scan" : "")
                          : ""}
                    </div>
                    {aiReadyWarning ? (
                      <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
                        {aiReadyWarning}
                      </div>
                    ) : (
                      ""
                    )}
                    {hasAiMetrics ? (
                      <React.Fragment>
                        {!isAiReady || !aiReadyFields.length ? (
                          <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
                            <strong>{"Quick tip:"}</strong>
                            &nbsp;
                            {" Try adding more data or manually cleaning this dataset"}
                          </div>
                        ) : (
                          ""
                        )}

                        <div className={styles.datasetReviewContent}>
                          <ReviewDatasetItem error={!isAiReady} text={selectedDataset.outcome} />
                          <div className={styles.datasetReviewDivider} />
                          <div className={styles.datasetReviewSubContent} style={{ maxHeight: "unset" }}>
                            <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
                              {"Aible found " +
                                aiReadyFields.length +
                                " " +
                                handlePlurals(aiReadyFields.length, "column") +
                                " that are possible predictors of your outcome"}
                            </div>
                            <ExpansionItem
                              limit={
                                isAiReady
                                  ? Math.min(6, aiReadyFields.length + 1)
                                  : aiReadyFields.length
                                    ? Math.min(6, aiReadyFields.length + 1)
                                    : 0
                              }
                            >
                              <ReviewDatasetItem
                                style={{ width: "100%" }}
                                noIcon
                                text={
                                  <React.Fragment>
                                    <ProblematicPredictorLabel noMargin noIgnore label={<strong>{"Column"}</strong>} />
                                    <ProblematicPredictorLabel
                                      noMargin
                                      noIgnore
                                      noTitle
                                      label={<strong>{"Information Score"}</strong>}
                                      info={
                                        "The AI Validation step checks to see if there is sufficient predictive power in any of your variables for building an AI model. It's okay if your data is messy, there can still be enough to build AI models. Each variable is scored on a scale of 0 - 10."
                                      }
                                      maxWidth={200}
                                    />
                                  </React.Fragment>
                                }
                              />
                              {aiReadyFields.map((w, i) => (
                                <ReviewDatasetItem
                                  style={{ width: "100%" }}
                                  isExpand
                                  noIcon
                                  key={i}
                                  text={
                                    <React.Fragment>
                                      <ProblematicPredictorLabel
                                        noMargin
                                        noIgnore
                                        label={w.label}
                                        warning={this.checkIsProblematicPredictor(w.label)}
                                      />
                                      <ProblematicPredictorBar value={w.value} isScore />
                                    </React.Fragment>
                                  }
                                />
                              ))}
                              {notAiReadyFields.map((w, i) => (
                                <ReviewDatasetItem
                                  isExpand
                                  noIcon
                                  error
                                  key={i}
                                  text={
                                    <React.Fragment>
                                      <ProblematicPredictorLabel
                                        noMargin
                                        noIgnore
                                        label={w.label}
                                        warning={this.checkIsProblematicPredictor(w.label)}
                                      />
                                      <ProblematicPredictorBar value={w.value} isScore />
                                    </React.Fragment>
                                  }
                                />
                              ))}
                            </ExpansionItem>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                  </ReviewDatasetColumn>
                  {selectedDataset ? (
                    <ReviewDatasetColumn isLarge>
                      <ProblematicPredictors
                        id={id}
                        selectedDataset={selectedDataset}
                        problematicPredictors={problematicPredictors}
                        predictors={predictors}
                        updateIgnored={updateIgnored}
                        ignored={ignored}
                        isDataMode={isDataMode}
                        options={options}
                      />
                    </ReviewDatasetColumn>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </AibleStep>
        </div>
      </div>
    );
  }
}

export class ReviewDatasetColumn extends React.PureComponent {
  render() {
    const { className, header, minWidth, style, noGrow, isLarge, ...retProps } = this.props;
    const retStyle = {
      ...style
    };
    if (noGrow) {
      retStyle.flexGrow = 0;
      retStyle.flexShrink = 0;
    }
    if (isLarge) {
      retStyle.flexBasis = 400;
    }
    return (
      <div
        {...this.retProps}
        className={styles.reviewDatasetColumn + (className ? " " + className : "")}
        style={retStyle}
      >
        {header ? <div className={styles.reviewDatasetColumnHeader}>{header}</div> : ""}
        <React.Fragment>{this.props.children}</React.Fragment>
      </div>
    );
  }
}

export class ReviewDatasetHeader extends React.PureComponent {
  render() {
    const { className, error, header, icon, noGrow, style } = this.props;
    const retStyle = {
      ...style
    };
    if (noGrow) {
      retStyle.flexGrow = 0;
      retStyle.flexShrink = 0;
    }
    return (
      <div className={styles.datasetReviewHeader + (className ? " " + className : "")}>
        {icon ? (
          icon
        ) : (
          <Icon
            type={error ? "times" : "check"}
            isRound
            background={error ? "red" : "green"}
            style={error ? { padding: "5px" } : undefined}
            size={24}
          />
        )}
        <span>{header}</span>
      </div>
    );
  }
}

export class ReviewDatasetItem extends React.PureComponent {
  render() {
    const {
      className,
      error,
      text,
      overlayTitle,
      overlay,
      icon,
      noIcon,
      isExpand,
      reviewHeaderStyle,
      overlayIcon,
      ...retProps
    } = this.props;
    return (
      <div {...retProps} className={styles.datasetReviewContent + (className ? " " + className : "")}>
        <div className={styles.datasetReviewHeaderContent}>
          {noIcon ? (
            ""
          ) : icon ? (
            icon
          ) : (
            <Icon type={error ? "timesRed" : "checkGreen"} isRound style={{ flexShrink: 0 }} />
          )}
          <span
            className={styles.datasetReviewHeaderText}
            style={{
              margin: noIcon ? "0px" : undefined,
              width: isExpand ? "100%" : undefined,
              ...reviewHeaderStyle
            }}
          >
            {text}
          </span>
          {overlay ? (
            <OverlayTrigger
              placement={"top"}
              trigger={["click"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top" title={overlayTitle}>
                  {overlay}
                </Popover>
              }
            >
              {overlayIcon ? (
                overlayIcon
              ) : (
                <FontAwesomeIcon icon={faInfo} className={styles.typeIcon} style={{ marginLeft: "6px" }} />
              )}
            </OverlayTrigger>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export class ExpansionItem extends React.Component {
  state = {
    show: false
  };

  render() {
    const {
      className,
      label,
      limit,
      noHeightLimit,
      bodyStyle,
      footerStyle,
      showAll,
      updateShowAll,
      children,
      ...retProps
    } = this.props;
    const { show } = this.state;
    const retlabel = label === undefined ? "View all columns" : label;
    const retLimit = isNaN(limit) ? 5 : limit;

    const retBodyStyle = bodyStyle ? { ...bodyStyle } : {};
    const retFooterStyle = footerStyle ? { ...footerStyle } : {};

    if (noHeightLimit) {
      retBodyStyle.maxHeight = "unset";
    }

    const retShow = showAll !== undefined ? showAll : show;
    return (
      <div
        {...retProps}
        className={styles.expansionWrapper + " " + (retShow ? styles.show : "") + " " + (className ? className : "")}
      >
        <div className={styles.expansionBody + " " + (retShow ? styles.show : "")} style={retBodyStyle}>
          {React.Children.map(children, (child, i) => {
            if (retShow || i < retLimit) {
              return child;
            } else {
              return "";
            }
          })}
        </div>
        <div className={styles.expansionFooter + " " + (retShow ? styles.show : "")} style={retFooterStyle}>
          <a
            onClick={() => {
              if (updateShowAll) {
                updateShowAll(!retShow);
              }
              this.setState({ show: !retShow });
            }}
          >
            {retShow ? "Hide" : retlabel}
          </a>
        </div>
      </div>
    );
  }
}
